export default __webpack_public_path__ + "static/media/notes2.bae7d293.png";